import styled from "styled-components";

export const InvoiceContainer = styled.div`
  ${(props) => `
    background-color: ${props.theme.colors.white};
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  border-radius: 1rem;
  display: grid;
  font-size: 1.4rem;
  font-weight: 500;
  margin-bottom: 1rem;
  padding: 0.5rem 1.5rem;

  div {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  input.checkInvoice {
    margin-right: 2rem;
  }

  .actions {
    flex-direction: row;
    gap: 1rem;
  }

  .main-info-header {
    align-items: flex-start;
  }

  .main-info-header p {
    margin: 0.5rem 0;
  }

  .id {
    color: ${(props) => props.theme.colors.gray};
    font-size: 1.4rem;
    font-weight: 500;
  }

  .ruc-id {
    color: ${(props) => props.theme.colors.gray};
    font-size: 1.2rem;
    font-weight: 600;
  }

  .clickable-element {
    cursor: pointer;
  }

  .comment-box {
    align-items: center;
    align-self: center;
    background-color: ${({ theme }) => theme.colors.primaryBlue};
    border-radius: 1rem;
    display: flex;
    height: 3.4rem;
    justify-content: center;
    width: 3.4rem;
  }
`;

export const VolanteId = styled.div`
  ${(props) => `
    color: ${props.theme.colors.primaryBlue};
  `}
  font-weight: 600;
`;

interface IStatusDiv {
  status?: string;
}
export const StatusDiv = styled.div<IStatusDiv>`
  ${(props) => {
    const status = props.status;
    let color,
      backgroundColor,
      cursor = "default";
    if (status === "problem") {
      color = props.theme.colors.supportRed;
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
      cursor = "pointer";
    } else if (status === "warning") {
      color = props.theme.colors.blackTextBody;
      backgroundColor =
        props.theme.colors.supportYellow + props.theme.transparencies.p30;
      cursor = "pointer";
    } else if (status === "ok") {
      color = props.theme.colors.betterGreen;
      backgroundColor =
        props.theme.colors.betterGreen + props.theme.transparencies.p10;
      cursor = "pointer";
    } else {
      color = props.theme.colors.gray;
      backgroundColor =
        props.theme.colors.gray72 + props.theme.transparencies.p20;
    }
    return `
      span {
        background-color: ${backgroundColor};
        color: ${color};
        cursor: ${cursor};
        font-size: 1.1rem;
        font-weight: 600;
        padding: 0.6rem;
        text-align: center;
      }
  `;
  }}
`;

export const StatusBar = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const StatusSection = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  position: relative;
`;

interface IColoredTag {
  hasExpired?: any;
}
export const ColoredTag = styled.div<IColoredTag>`
  ${(props) => `
    color: ${
      props.hasExpired
        ? props.theme.colors.accentRed
        : props.theme.colors.blackTextTitle
    };
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
`;
